module.exports = __webpack_public_path__ + "img/2_select_tutorial.d9f767ef.gif";